// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"da877cb3","341":"d04918e4","438":"5829b885","650":"06d11d04","706":"58f5ce34","726":"6f3e331e"}[chunkId] + ".chunk.js";
};